// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
	LoginComponent,
	RoleGuard,
	AuthenticateComponent,
	AuthGuard,
	SystemInfoComponent
} from '@cv-invision/core';
import { AuthFromKeyComponent } from './components/auth-from-key/auth-from-key.component';

export const AppRoute: Routes = [
	{ path: '', canActivate: [AuthGuard], pathMatch: 'full', component: LoginComponent },

	// QC Authentication  ---------------------------------------------
	{
		path: 'authenticate',
		component: AuthenticateComponent
	},
	{
		path: 'unauthorized',
		component: LoginComponent
	},
	{
		path: 'logout',
		component: LoginComponent
	},
	{
		path: 'system-info',
		component: SystemInfoComponent,
		canActivate: [AuthGuard],
		data: {
			subComponentShow: false
		}
	},
	// QC Intelligence Module ---------------------------------------------
	{
		path: 'intelligence',
		canActivate: [RoleGuard],
		loadChildren: () =>
			import('@cv-invision/cv.invision-intelligence.ux').then(m => m.IntelligenceModule)
	},
	// Appraisal Desktop Module -------------------------------------------
	{
		path: 'desktop',
		loadChildren: () =>
			import('@cv-invision/cv.invision-desktop.ux').then(m => m.AppraisalDesktopModule)
	},
	// Identity System ----------------------------------------------------
	{
		path: 'identity-system',
		canActivate: [RoleGuard],
		loadChildren: () =>
			import('@cv-invision/cv.user-management.ux').then(m => m.IdentitySystemModule),
		data: {
			module: 'identity-system'
		}
	},
	// Rule Engine --------------------------------------------------------
	{
		path: 'rule-engine',
		canActivate: [RoleGuard],
		loadChildren: () => import('@cv-invision/cv.rule-engine.ux').then(m => m.RuleEngineModule),
		data: {
			module: 'rule-engine'
		}
	},
	// Global Configuration --------------------------------------------------------
	{
		path: 'global-configuration',
		canActivate: [RoleGuard],
		loadChildren: () =>
			import('@cv-invision/cv.global-configuration.ux').then(m => m.GlobalConfigurationModule)
	},
	// Smart Assign --------------------------------------------------------
	{
		path: 'smart-assign',
		canActivate: [RoleGuard],
		loadChildren: () =>
			import('@cv-invision/cv.smart-assign.ux').then(m => m.SmartAssignModule),
		data: {
			breadcrumb: false,
			module: 'smart-assign'
		}
	},

	// Page not found
	{
		path: '**',
		redirectTo: '/'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(AppRoute, {})],
	exports: [RouterModule]
})
export class AppRouteModule {}
